import { Injectable } from '@angular/core';
import { toLabelArray, undefOrEmpty } from '@app/shared/functions/utils';
import { Subscription } from 'rxjs';
import { OrderItemData, QuotationData } from '../customer-order/customer-order-data.service';
import { CustomerOrderService } from './customer-order.service';

export interface OrderTabOrderItemData {
  category: string;
  product: string;

  qty: string;
  qtyUom: string;

  imageUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerOrderDataAuthService {
  private customerOrderData: { [key: string]: any } = {};

  private customerOrderDataStruct: { [key: string]: any } = {};

  queryOrder!: Subscription;

  orderId!: string;

  constructor(private customerOrderService: CustomerOrderService) {}

  public cleanUp() {
    this.queryOrder?.unsubscribe();
  }

  runService(orderId: string): Promise<void> {
    this.orderId = orderId;

    return new Promise((resolve, reject) => {
      this.queryOrder = this.customerOrderService.getApiCustomerOrder(this.orderId).subscribe({
        next: (response) => {
          this.customerOrderData = response.data;

          this.setOrderDataIntoStructure();

          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  setOrderDataIntoStructure(): void {
    this.customerOrderDataStruct = {
      customerName: this.customerOrderData['project'].customer.name,
    };

    this.customerOrderDataStruct['enquiryBasicData'] = {
      enquiryNum: this.customerOrderData['enquiryNum'].toUpperCase(),
      enquiryDate: this.customerOrderData['enquiryDate'],
      deliveryAddress: this.customerOrderData['project'].projectLocation,
      deliveryPincode: this.customerOrderData['project'].projectPincode,
    };

    this.customerOrderDataStruct['publicRequirementsId'] = this.customerOrderData['publicId'];

    this.customerOrderDataStruct['relationshipManagerData'] = {
      name: this.customerOrderData['customerOrderOwner'].name,
      email: this.customerOrderData['customerOrderOwner'].email,
      mobile: this.customerOrderData['customerOrderOwner'].mobile,
    };

    if (this.customerOrderData['customerOrderOwner'].manager) {
      this.customerOrderDataStruct['relationshipManagerData']['manager'] = {
        name: this.customerOrderData['customerOrderOwner'].manager.name,
        email: this.customerOrderData['customerOrderOwner'].manager.email,
        mobile: this.customerOrderData['customerOrderOwner'].manager.mobile,
      };
    }

    let orderItems: OrderItemData[] = [];

    for (let i = 0; i < this.customerOrderData['customerOrderRequirementItemList'].length; i++) {
      const orderItem = this.customerOrderData['customerOrderRequirementItemList'][i];

      orderItems.push({
        category: undefOrEmpty(orderItem['materialCategory']?.label),
        product: undefOrEmpty(orderItem['materialProduct']?.label),
        make: toLabelArray(orderItem['materialMakeList'], 'make'),
        grade: toLabelArray(orderItem['materialGradeList'], 'grade'),
        brand: toLabelArray(orderItem['materialBrandList'], 'brand'),
        type: undefOrEmpty(orderItem['materialType']?.label),
        property: undefOrEmpty(orderItem['materialProperty']?.label),
        dimension: undefOrEmpty(orderItem['materialDimension']?.label),
        customDimensions: orderItem['materialCustomDimensions'],
        qty: orderItem['qty'] + ' ' + orderItem['qtyUom'].value,
      });
    }

    this.customerOrderDataStruct['orderItemList'] = orderItems;

    let quotationList: QuotationData[] = [];

    for (let i = 0; i < this.customerOrderData['quotationListPublic'].length; i++) {
      const quotation = this.customerOrderData['quotationListPublic'][i];

      let message: string = '';

      if (quotation['customerPoNum'] && quotation['customerPoDate']) {
        message = 'Accepted with PO No. ' + quotation['customerPoNum'] + ' on ' + quotation['customerPoDate'];
      }

      quotationList.push({
        quotationNum: quotation['quotationNum'],
        quotationPdfUrl: quotation['quotationPdfPublicFileUrl'],
        quotationMessage: message,
      });
    }

    this.customerOrderDataStruct['quotationList'] = quotationList;
  }

  getOrderData(): { [key: string]: any } {
    return this.customerOrderData;
  }

  getOrderResponseDataString() {
    let something: string = JSON.stringify(this.customerOrderData, null, 2);
    something = something.replace(/(?<=[a-z])([A-Z])/g, '_$1').toLowerCase();

    return something;
  }

  getOrderDataStructured(): { [key: string]: any } {
    return this.customerOrderDataStruct;
  }
}

export function consolidateOrderItems(dataArray: any[]): any[] {
  for (let i = 0; i < dataArray.length; i++) {
    const orderItems = dataArray[i].orderItems;

    dataArray[i].orderItems = [];

    orderItems.forEach((orderItem: OrderTabOrderItemData) => {
      const is_item_category_product_unique: boolean = dataArray[i].orderItems.reduce(
        (accumulator: boolean, currentValue: OrderTabOrderItemData) => {
          if (
            accumulator &&
            orderItem.category == currentValue.category &&
            orderItem.product == currentValue.product
          ) {
            accumulator = false;
          }

          return accumulator;
        },
        true as boolean
      );

      if (is_item_category_product_unique) {
        dataArray[i].orderItems.push(orderItem);
      } else {
        const already_index = search_already_item_index(orderItem, dataArray[i].orderItems);

        dataArray[i].orderItems[already_index].qty = (
          parseFloat(dataArray[i].orderItems[already_index].qty) + parseFloat(orderItem.qty)
        ).toFixed(2);
      }
    });
  }

  return dataArray;
}

function search_already_item_index(orderItem: OrderTabOrderItemData, items: any[]): number {
  for (let i = 0; i < items.length; i++) {
    if (orderItem.category == items[i].category && orderItem.product == items[i].product) {
      return i;
    }
  }

  return -1;
}
